class HodakyeeFooter extends HTMLElement {
  connectedCallback() {
    this.onToggle = this.onToggle.bind(this);
    this.querySelectorAll('[data-footer-accordion]').forEach((details) => details.addEventListener('toggle', this.onToggle));
  }

  disconnectedCallback() {
    this.querySelectorAll('[data-footer-accordion]').forEach((details) => details.removeEventListener('toggle', this.onToggle));
  }

  onToggle(event) {
    if (!event.currentTarget.open) return;
    this.querySelectorAll('[data-footer-accordion][open]').forEach((details) => {
      if (details !== event.currentTarget) details.open = false;
    });
  }
}

if (!customElements.get('hodakyee-footer')) customElements.define('hodakyee-footer', HodakyeeFooter);
